export namespace Accordion {
	let Accordion = () => {

        let accordionItems = document.querySelectorAll('.js-acc-trigger');
        

        accordionItems.forEach(function(accordionItem){
            let parent = accordionItem.closest('.js-acc-item')
            accordionItem.addEventListener('click', e => {
                e.preventDefault();
                parent.classList.toggle('state-open');
            })
        });
    }

	export const init = () => {
		Accordion();
	}
}
